import { useContext, useEffect, useRef, useState } from 'react';

import NewsCard from '@/components/game/ui/card/NewsCard';
import SeasonalCard from '@/components/game/ui/card/SeasonalCard';
import SummitCard from '@/components/game/ui/card/SummitCard';
import { GameContext, ViewContext } from '@/state/contexts';
import { getPlayerStateWithId } from '@/util/player';
import '@/style/DisplayCardImg.css';
import '@/style/UI.css';

const TickerElement = ({ tickerItem, cardId, cardType, color }) => {
	const [over, setOver] = useState(false);

	function displayCardByType() {
		if (cardType === 'seasonal') {
			return <SeasonalCard cardId={cardId} width={0} height={0} />;
		} else if (cardType === 'news') {
			return <NewsCard cardId={cardId} width={0} height={0} />;
		} else if (cardType === 'summit') {
			return <SummitCard cardId={cardId} width={0} height={0} />;
		}
	}

	function getColor(color) {
		if (color === 'yellow') {
			return '#f6de9a';
		} else if (color === 'blue') {
			return '#15bedb';
		} else if (color === 'red') {
			return '#efa1ae';
		} else if (color === 'green') {
			return '#556341';
		} else if (color === 'fail') {
			return '#fb2d01';
		}

		return 'white';
	}

	if (cardId === -1) {
		return (
			<p className="tickerItem" style={{ color: getColor(color) }}>
				{tickerItem}
			</p>
		);
	}

	return (
		<div
			className="tickerCardImgHover"
			onMouseOver={() => setOver(true)}
			onMouseOut={() => setOver(false)}
		>
			{over && <div className="centerImg">{displayCardByType()}</div>}
			<p className="tickerItem" style={{ color: getColor(color) }}>
				{tickerItem}
			</p>
		</div>
	);
};

const TickerWithHover = () => {
	const {
		players,
		playerStateArray,
		myState,
		ticker,
		moveForward,
		moveBackward,
		resumeGame,
		setLiveView,
		liveStateView,
		stepTutorial,
	}: any = useContext(GameContext);

	const endOfMessagesRef: any = useRef(null);

	const showPlayers = false;

	const { showTicker, setShowTicker, setShowAdminStateModal }: any =
		useContext(ViewContext);

	useEffect(() => {
		// Scroll to the bottom of the messages element
		if (endOfMessagesRef.current) {
			endOfMessagesRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	}, [ticker]);

	if (!ticker) return;

	function toggleTicker() {
		setShowTicker(!showTicker);
	}

	function viewAdminStateModal() {
		setShowAdminStateModal(true);
	}

	function applyPrevStatePatch() {
		moveBackward();
	}

	function applyNextStatePatch() {
		moveForward();
	}

	function resumeCurrentState() {
		resumeGame();
	}

	function getColor(color) {
		if (color === 'yellow') {
			return '#f6de9a';
		} else if (color === 'blue') {
			return '#15bedb';
		} else if (color === 'red') {
			return '#efa1ae';
		} else if (color === 'green') {
			return '#556341';
		} else if (color === 'fail') {
			return '#fb2d01';
		}

		return 'white';
	}

	function getCardIdForTickerItem(tickerItem) {
		let cardId = -1;
		let cardType = '';
		let color = 'white';
		const tickerArr = tickerItem.split(' ');

		// logg("tickerArr");
		// logg(tickerArr);

		if (tickerArr[0] === 'Player') {
			const pId = parseInt(tickerArr[1]);
			if (pId === 0 || pId === 1 || pId === 2 || pId === 3) {
				const playerState = getPlayerStateWithId(playerStateArray, pId);

				if (playerState && playerState.color) {
					color = playerState?.color;
				}
			}
		}

		if (tickerArr[0] === 'Player' && tickerArr[2] === 'won') {
			cardId = parseInt(tickerArr[tickerArr.length - 1]);
			cardType = 'seasonal';
		}

		for (let i = 0; i < tickerArr.length; i++) {
			if (tickerArr[i] === 'failed') {
				color = 'fail';
			}
			if (tickerArr[i] === 'playCard') {
				cardId = parseInt(tickerArr[i + 1]);
				cardType = 'seasonal';
				break;
			} else if (tickerArr[i] === 'playEquipmentById') {
				cardId = parseInt(tickerArr[i + 1]);
				cardType = 'seasonal';
				break;
			} else if (tickerArr[i] === 'playSummitCard') {
				cardId = parseInt(tickerArr[i + 1]);
				cardType = 'summit';
				break;
			} else if (tickerArr[i] === 'News' && tickerArr[i + 1] === 'card') {
				let cardTempId = tickerArr[i + 2];
				cardId = parseInt(
					cardTempId.substring(0, cardTempId.length - 1)
				);
				cardType = 'news';
			}
		}

		return { cardId, cardType, color };
	}

	return (
		<div className="sideBarSizer">
			{showPlayers && (
				<ul>
					{playerStateArray
						.toSorted((a, b) => a.playerId - b.playerId)
						.map((p) => {
							return (
								<li style={{ color: getColor(p.color) }}>
									{p.username} (Player {p.playerId})
								</li>
							);
						})}
				</ul>
			)}
			<div className="scroller">
				{ticker &&
					ticker.length > 0 &&
					ticker.map((tickerItem, index) => {
						const { cardId, cardType, color } =
							getCardIdForTickerItem(tickerItem);
						return (
							<TickerElement
								key={`ticker-element-${index}`}
								tickerItem={tickerItem}
								cardId={cardId}
								cardType={cardType}
								color={color}
							/>
						);
					})}
				<div ref={endOfMessagesRef} />{' '}
				{/* This is the marker for scrolling */}
			</div>

			<div className="ticker-button-container">
				{false && ( // hide for now, doesn't make sense for this button to disappear when you need it again
					<button
						className="split-button-ticker"
						onClick={toggleTicker}
					>
						<span className="left-text">
							🧾 {showTicker ? <>Hide</> : <>Show</>} Ticker
						</span>
					</button>
				)}
				{myState.isAdmin && (
					<button
						className="split-button-ticker"
						onClick={(e) => viewAdminStateModal()}
					>
						<span className="left-text">Show Admin State</span>
					</button>
				)}
				<button
					className="split-button-ticker"
					onClick={(e) => applyPrevStatePatch()}
				>
					<span className="left-text">⬅️ Previous State</span>
				</button>
				<button
					className="split-button-ticker"
					onClick={(e) => applyNextStatePatch()}
				>
					<span className="left-text">➡️ Next State</span>
				</button>
				<button
					className="split-button-ticker"
					onClick={(e) => resumeCurrentState()}
				>
					<span className="left-text">
						{liveStateView ? '⏸️ Pause Game' : '▶️ Resume Game'}
					</span>
				</button>
			</div>
		</div>
	);
};

export default TickerWithHover;
